@if (isWaiting) {
  <div class="progress-spinner">
    <p-progressSpinner class="custom-spinner" ariaLabel="loading"></p-progressSpinner>
  </div>
}